import React from "react"
import { Container, Paper, AppBar, Toolbar, Grid } from "@mui/material"
import { LOGIN_ROUTE } from "../../../../constants/routes"
import FacilitynetLogo from "../../../../shared/layouts/assets/facilit-net-logo.svg"
import { LanguageSelector } from "../../../../shared/components/languageSelector/LanguageSelector"
import { Link, Outlet } from "react-router-dom"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    container: {
        padding: "8rem 0",
    },
    paper: {
        padding: " 0 1rem",
        display: "flex",
        flexDirection: "column",
        maxWidth: "37rem",
        margin: "0 auto",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    logo: {
        width: "auto",
    },
    logoLink: {
        display: "flex",
        alignItems: "center",
    },
}))

export function PublicLayout() {
    const { classes } = useStyles()

    return (
        <Container className={classes.container}>
            <AppBar position="fixed" color="transparent" elevation={0}>
                <Toolbar>
                    <Grid container justifyContent="space-between" className={classes.header}>
                        <Link className={classes.logoLink} to={LOGIN_ROUTE}>
                            <img className={classes.logo} src={FacilitynetLogo} alt="Facilitynet" />
                        </Link>
                        <LanguageSelector color="black" />
                    </Grid>
                </Toolbar>
            </AppBar>

            <Paper className={classes.paper} elevation={0}>
                <Outlet />
            </Paper>
        </Container>
    )
}
